export default __webpack_public_path__ + "static/media/InsideEars_07.a2b41669.png";